import React, { useState } from 'react';
import { authService } from '../services/api';

const PasswordGate = ({ onAuthorized }) => {
  const [password, setPassword] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!password.trim()) return;

    setIsVerifying(true);
    setErrorMsg('');

    try {
      // Actively verify the password with the backend
      const isValid = await authService.verifyPassword(password);
      if (isValid) {
        localStorage.setItem('rehearsal_password', password);
        onAuthorized(password);
      }
    } catch (err) {
      // A 401 response will throw an error here
      setErrorMsg('Incorrect password. Please try again.');
      setPassword('');
    } finally {
      setIsVerifying(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] bg-blue-900 flex items-center justify-center p-6 text-white">
      <div className="max-w-md w-full space-y-8 text-center">
        <div className="space-y-4">
          <div className="bg-white/10 w-20 h-20 rounded-3xl flex items-center justify-center mx-auto backdrop-blur-md border border-white/20">
            <svg className="w-10 h-10 text-blue-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 00-2 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold tracking-tight">bChoir</h1>
          <p className="text-blue-100/70">Please enter the password to access the music scores.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="password"
            placeholder="Password"
            className={`w-full p-4 bg-white/10 border ${errorMsg ? 'border-red-400' : 'border-white/20'} rounded-xl outline-none focus:ring-2 focus:ring-white/50 transition text-center text-xl tracking-widest placeholder:tracking-normal placeholder:text-blue-200/50`}
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setErrorMsg('');
            }}
            disabled={isVerifying}
            autoFocus
          />
          {errorMsg && (
             <p className="text-red-400 text-sm font-bold tracking-wide animate-pulse">{errorMsg}</p>
          )}
          <button 
            type="submit"
            disabled={isVerifying}
            className="w-full p-4 bg-white text-blue-900 font-bold rounded-xl hover:bg-blue-50 transition shadow-lg disabled:opacity-50 flex justify-center items-center h-[60px]"
          >
            {isVerifying ? (
               <div className="w-6 h-6 border-2 border-blue-900 border-t-transparent rounded-full animate-spin"></div>
            ) : (
               "Enter Archive"
            )}
          </button>
        </form>

        <p className="text-[10px] uppercase tracking-widest font-bold text-blue-200/40 pt-10">
          bChoir &copy; 2026
        </p>
      </div>
    </div>
  );
};

export default PasswordGate;
